import React, { FC } from 'react';
import Section from 'evcharging/containers/layout/Section';
import Container from 'evcharging/components/Container';
import Spacer from 'evcharging/components/Spacer';
import useI18n from 'evcharging/hooks/useI18n';
import Caption from 'evcharging/components/Caption';
import glance1 from 'assets/about-us/glance-1.png';
import glance2 from 'assets/about-us/glance-2.png';
import glance3 from 'assets/about-us/glance-3.png';
import glance4 from 'assets/about-us/glance-4.png';
import glance5 from 'assets/about-us/glance-5.png';
import { Theme } from 'evcharging/app/themes';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import AtGlanceCard from 'containers/about-us/AtGlanceCard';
import clsx from 'clsx';

const AtGlance: FC = () => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const { t } = useI18n();

  const items = [
    { image: glance1, title: t('about-us.revolutionized-energy') },
    { image: glance2, title: t('about-us.all-in-one-energy') },
    { image: glance3, title: t('about-us.tailored-savings') },
    { image: glance4, title: t('about-us.eco-friendly-approaches') },
    { image: glance5, title: t('about-us.expert-guidance') },
  ]

  return (
    <Section background={'middle'}>
      <Container>
        <Caption>
          {t('about-us.energy5-at')}
        </Caption>
        <Spacer value={48} />
        <div className={styles.wrapper}>
          {items.slice(0, 3).map((item, index) => (
            <AtGlanceCard key={index} {...item}/>
          ))}
        </div>
        <div className={clsx(styles.wrapper, styles.wrapper2)}>
          {items.slice(3).map((item, index) => (
            <AtGlanceCard key={index} {...item}/>
          ))}
        </div>
      </Container>
    </Section>
  );
};

const createStyles = (theme: Theme) => ({
  wrapper: css`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  `,
  wrapper2: css`
    margin: 0 auto;
    max-width: 820px;
  `
});

export default AtGlance;
